import script from "./Autoscaler.vue?vue&type=script&setup=true&lang=ts"
export * from "./Autoscaler.vue?vue&type=script&setup=true&lang=ts"

import "./Autoscaler.vue?vue&type=style&index=0&id=e84106fa&lang=scss&scoped=true"

import exportComponent from "../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e84106fa"]])

export default __exports__